import { ReactNode } from 'react';

import Button from '../../../../../../components/ui/buttons/Button';

type OfferLinkButtonProps = {
  onClick: () => void;
  children: ReactNode;
};

const OfferLinkButton = ({ onClick, children }: OfferLinkButtonProps) => (
  <Button
    variant="link"
    onClick={onClick}
    color="oceanBoatBlue"
    fontSize="12px"
    fontWeight="600"
    minW={0}
  >
    {children}
  </Button>
);

export default OfferLinkButton;
